// extracted by mini-css-extract-plugin
export var dataCell = "_re-2";
export var dataRow = "_re-0";
export var headerRow = "_re-1";